import React, { FunctionComponent, useEffect, useState } from 'react';
import RetrieveForm from 'scenes/common/components/Forms/RetrieveForm';
import { useDispatch, useSelector } from 'react-redux';
import { ApiState } from 'scenes/common/helpers/apiData/types';
import useNextPage from 'scenes/payments/hooks';
import { fetchPolicy } from 'scenes/payments/redux/payment/thunks';
import { getLoadingStatus } from 'scenes/payments/redux/payment/selectors';
import { LoadingSpinner } from 'components';
import {
  FormFlows,
  POSTCODE_LENGTH,
} from 'scenes/common/components/Forms/RetrieveForm/RetrieveForm';
import useFetchPolicyWithEncodedQueryParams from 'scenes/payments/hooks/useFetchPolicyWithEncodedQueryParams';
import getConfigData from 'scenes/payments/api/config';
import { getMaintenanceStatus } from 'scenes/payments/redux/config/configSelectors';
import redirectToOutagePage from 'scenes/outage/helpers/config';
import { useHistory } from 'react-router';
import { ErrorMessage } from 'scenes/payments/components/Errors';

import { resetConfig } from 'scenes/payments/redux/config/configActions';
import { resetPayment } from 'scenes/payments/redux/payment/paymentActions';

export const RetrievePolicy: FunctionComponent = () => {
  const nextPage = useNextPage();
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState<JSX.Element | null>(null);
  const isPolicyLoading = useSelector(getLoadingStatus) === ApiState.Loading;
  const handleSubmit = async (quoteNumber: string, postcode: string) => {
    try {
      await dispatch(fetchPolicy(quoteNumber, postcode));
      nextPage();
    } catch ({ data, name }) {
      setErrorMessage(<ErrorMessage data={data} type={name} />);
    }
  };

  useEffect(() => {
    getConfigData(dispatch);
    dispatch(resetConfig());
    dispatch(resetPayment());
  }, [dispatch]);

  useFetchPolicyWithEncodedQueryParams();

  const maintenancePageActive = useSelector(getMaintenanceStatus);
  const handleValidation = (isValid: boolean, target: string) =>
    setErrorMessage(
      isValid || target.length === POSTCODE_LENGTH ? null : errorMessage
    );

  useEffect(() => {
    if (maintenancePageActive) {
      redirectToOutagePage(history);
    }
  }, [maintenancePageActive, history]);

  return (
    <>
      {isPolicyLoading && <LoadingSpinner label="Loading your policy" />}
      {!isPolicyLoading && (
        <RetrieveForm
          errorMessageElement={errorMessage}
          defaultQuoteNumber=""
          displayDOBQuestion={false}
          buttonText="Retrieve policy"
          questionHeader="Policy number"
          header="Make a payment"
          formFlowType={FormFlows.PAYMENT}
          onSubmitCallback={handleSubmit}
          handleValidationCallback={handleValidation}
        />
      )}
    </>
  );
};

export default RetrievePolicy;
